
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoCreditNoteDtDialog extends Serenity.Extensions.GridEditorDialog<PoCreditNoteDtRow> {
        protected getFormKey() { return PoCreditNoteDtForm.formKey; }
        // protected getIdProperty() { return PoCreditNoteDtRow.idProperty; }
        protected getLocalTextPrefix() { return PoCreditNoteDtRow.localTextPrefix; }
        protected getNameProperty() { return PoCreditNoteDtRow.nameProperty; }
        // protected getService() { return PoCreditNoteDtService.baseUrl; }
        // protected getDeletePermission() { return PoCreditNoteDtRow.deletePermission; }
        // protected getInsertPermission() { return PoCreditNoteDtRow.insertPermission; }
        // protected getUpdatePermission() { return PoCreditNoteDtRow.updatePermission; }

        protected form = new PoCreditNoteDtForm(this.idPrefix);
        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
        public purratio: number;
        public purpz: number;
        public lsprun: number;
        private qty: number;
        public purunit: string;
        public HdPostfg: number;

        constructor() {
            super();
            this.form = new PoCreditNoteDtForm(this.idPrefix);
            // if(this.form.PiLineId.value!=null){
            // let q = Q.tryFirst(PoPurInvoiceDtRow.getLookup().items, x => x.Id == this.form.PiLineId.value)
            //     this.purunit = q.PurUnit
            //     this.purratio = q.PurUnitRatio
            //     this.purprice = q.PurUnitPrice
            //     this.qty = q.StkQty - q.QtyUse
            //     }
            this.form.DiscText.changeSelect2(e => {
                var discStr = this.form.DiscText.value;
                if (discStr) {
                    //20%,5%,200
                    let a = discStr.split(",")
                    console.log(a)
                    var totalAmt = this.form.BeforeDiscAmt.value;
                    var discamt = 0
                    //var net = 0

                    for (var po of a) {

                        if (po.includes("%")) {
                            let a = po.replace("%", "");
                            let b = Number(a);
                            console.log(b)
                            let amt = totalAmt * b / 100
                            discamt = discamt + amt;
                            totalAmt = totalAmt - amt;
                        } else {
                            let x = Number(po)
                            discamt = discamt + x
                            totalAmt = totalAmt - x;
                        }

                    }

                    console.log("Lasttotal:" + totalAmt)
                    console.log("DiscAmt:" + discamt)

                    this.form.DiscAmt.value = discamt
                    this.form.ItemAmt.value = totalAmt
                    this.form.ItemNetAmt.value = totalAmt - (this.form.AlocalteDiscAmt.value || 0)

                    // const disAmt =  (totalAmt * discStr) / 100;
                    // this.form.DiscAmt.value = disAmt;
                    //this.form.NetAmt.value = totalAmt - disAmt;
                    this.CalVat();

                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.BeforeDiscAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });


            this.form.UnitChange.change(e => {

                var change = this.form.UnitChange.value
                var skucode: string = this.form.SkuCode.value;
                var w = this.form.PiLineId.value;
                if (w > 0 && w!= null && this.HdPostfg == 0) {
                    let q = Q.tryFirst(PoPurInvoiceDtRow.getLookup().items, x => x.Id == w)
                    this.purunit = q.PurUnit
                    this.purratio = q.PurUnitRatio
                    this.purprice = q.PurUnitPrice
                    this.qty = q.StkQty - q.QtyUse
                    if (change == "1") {
                        if (q.UnitChange == 1) {

                            this.form.PurUnitPrice.value = q.PurUnitPrice;
                            this.form.PurUnit.value = q.PurUnit;
                            this.form.Qty.value = this.qty / this.purratio



                            this.Calamt();
                        } else {
                            Q.warning("รับเข้า ด้วยหน่วยสต๊อก ไม่สามารถคืนเป็นหน่อยซื้อได้")
                            this.form.UnitChange.value = "0";
                        }
                    }
                    if (change == "0") {

                        this.form.PurUnitPrice.value = q.PurUnitPrice / this.purratio;
                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[skucode].StkUnit;
                        this.form.Qty.value = this.qty

                        this.Calamt();

                    }


                }
            });

            this.form.Qty.changeSelect2(e => {
                var skucode = Q.toId(this.form.Qty.value);
                if (skucode != null) {

                    var PrRef: string = this.form.PiRefDocNo.value

                    if (!Q.isEmptyOrNull(PrRef) && this.HdPostfg == 0) {
                        this.checkOverQty();

                    }

                    this.Calamt();
                }
            });

            this.form.PurUnitPrice.changeSelect2(e => {
                var skucode = Q.toId(this.form.PurUnitPrice.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

            this.form.BeforeDiscAmt.changeSelect2(e => {
                var skucode = Q.toId(this.form.BeforeDiscAmt.value);
                if (skucode != null) {

                    this.Calamt();

                }
            });

        }

        private checkOverQty() {
            var PrRef: string = this.form.PiRefDocNo.value
            var line = this.form.PiLineId.value
            let pr = Q.first(Purchase.PoPurInvoiceDtRow.getLookup().items, x => x.Id == line && x.SysDocNo == PrRef);
            let lessqty = pr.StkQty - pr.QtyUse
            if (lessqty < (this.form.Qty.value * this.form.PurUnitRatio.value)) {
                Q.warning("จำนวนคงเหลือ ไม่เพียงพอ")
                this.form.Qty.value = lessqty / this.form.PurUnitRatio.value
            }
        }

        // protected validateBeforeSave(): boolean {
        //     super.validateBeforeSave();
        //     this.checkOverQty()
        //     return this.validateBeforeSave();
        // }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
            buttons.push(
                {

                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **
                    },
                }
            );

            return buttons;
        }


        protected afterLoadEntity() {
            let self = this;
            this.toolbar.findButton('clone-button').hide();
            this.toolbar.findButton('localization-button').hide();
            this.toolbar.findButton('undo-delete-button').hide();
            Serenity.EditorUtils.setReadOnly(this.form.PurUnitPrice, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
            this.HdPostfg = 0;
                var sysdoc = this.entity.SysDocNo;
                console.log(sysdoc)
                if (!Q.isEmptyOrNull(sysdoc)) {
                   
                    let  q = Q.tryFirst(PoCreditNoteRow.getLookup().items, x => x.SysDocNo == sysdoc)
                    if(q.ApproveFg == 1 || q.PostFg == 1|| q.CancelFg == 1|| q.SendForAppfg == 1){
                    this.HdPostfg = 1;
                    // this.toolbar.findButton('button-saveandnew').toggleClass('disabled', false);
                    // this.toolbar.findButton('button-saveandnew').hide();
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);
                    Serenity.EditorUtils.setReadOnly(this.form.Qty, true);                    
                    Serenity.EditorUtils.setReadOnly(this.form.Remark, true);                    
                    Serenity.EditorUtils.setReadOnly(this.form.UnitChange, true);
                    }
                }
           
                
           
            

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
            let f = this.form;
            // if (f.SkuCode.value != null) {
            /* let self = this;*/

            // self.toolbar.findButton("button-skucode").addClass("skuStockStatus");
            // self.toolbar.findButton('button-newdelete').addClass("skuEssential");
            // }

        }

        private Calamt() {



            this.form.BeforeDiscAmt.value = (this.form.PurUnitPrice.value) * (this.form.Qty.value);

            // this.form.ItemAmt.value = (this.form.BeforeDiscAmt.value - this.form.DiscAmt.value) 

            // this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0);
            // console.log(this.form.DiscAmt.value + "dis");
            this.distext();


        }




        private distext() {
            var discStr = this.form.DiscText.value;

            if (!Q.isEmptyOrNull(discStr)) {
                //20%,5%,200

                let a = discStr.split(",")
                console.log(a)
                var totalAmt = this.form.BeforeDiscAmt.value;
                var discamt = 0
                //var net = 0

                for (var po of a) {

                    if (po.includes("%")) {
                        let a = po.replace("%", "");
                        let b = Number(a);
                        console.log(b)
                        let amt = totalAmt * b / 100
                        discamt = discamt + amt;
                        totalAmt = totalAmt - amt;
                    } else {
                        let x = Number(po)
                        discamt = discamt + x
                        totalAmt = totalAmt - x;
                    }

                }

                console.log("Lasttotal:" + totalAmt)
                console.log("DiscAmt:" + discamt)

                this.form.DiscAmt.value = discamt
                this.form.ItemAmt.value = totalAmt
                this.form.ItemNetAmt.value = totalAmt - (this.form.AlocalteDiscAmt.value || 0)

                // const disAmt =  (totalAmt * discStr) / 100;
                // this.form.DiscAmt.value = disAmt;
                //this.form.NetAmt.value = totalAmt - disAmt;
                this.CalVat();

            } else {
                this.form.DiscAmt.value = 0
                this.form.ItemAmt.value = this.form.BeforeDiscAmt.value
                this.form.ItemNetAmt.value = this.form.ItemAmt.value - (this.form.AlocalteDiscAmt.value || 0)
                this.CalVat();
            }
        }

        private CalVat() {


            const Totalafterdis = this.form.ItemNetAmt.value

            var vatRate = this.form.VatRate.value

            var salev = this.form.SalesVatTypes.value

            console.log("vattype:" + salev)

            if (salev == "E") {
                this.form.ItemVatAmt.value = (Totalafterdis * (vatRate / 100));
                this.form.ItemExVatAmt.value = Totalafterdis
                this.form.ItemNetCostValue.value = Totalafterdis + this.form.ItemVatAmt.value + this.form.ItemExciseTaxAmt.value
            }    //vat นอก       
            else {

                let vat = (Totalafterdis * vatRate) / (vatRate + 100);
                this.form.ItemVatAmt.value = vat
                this.form.ItemExVatAmt.value = Totalafterdis - vat
                this.form.ItemNetCostValue.value = Totalafterdis + this.form.ItemExciseTaxAmt.value
            }




        }

    }
}